import { Component, computed, inject } from '@angular/core';
import { Message } from 'primeng/message';
import { TherapistStateService } from '@therapist/shared/services/state/therapist-state.service';
import { TherapistAccessStateEnum } from '@therapist/shared/models/subscription/therapist-access-state.enum';
import { SUPPORT_EMAIL } from '../../constants/support.const';

/** Warntext bei fehlgeschlagener Abbuchung; wird auch auf der Abo-Seite angezeigt. */
export const PAYMENT_OVERDUE_MESSAGE = 'Die letzte Abbuchung ist fehlgeschlagen. An die E-Mail-Adresse, mit der das Abo abgeschlossen wurde, '
  + 'wurde eine Nachricht mit einem Link zum Aktualisieren der Zahlungsmethode gesendet. Ohne Aktualisierung endet das Abo. '
  + `Bei Fragen: ${SUPPORT_EMAIL}.`;

@Component({
  selector: 'sana-tp-subscription-banner',
  imports: [
    Message
  ],
  templateUrl: './subscription-banner.component.html',
  styleUrl: './subscription-banner.component.scss'
})
export class SubscriptionBannerComponent {

  readonly #therapistState = inject(TherapistStateService);

  protected readonly isPaymentOverdue = computed(() => this.#therapistState.accessState() === TherapistAccessStateEnum.PaymentOverdue);
  protected readonly message = PAYMENT_OVERDUE_MESSAGE;
}
